import CompanyFilesContainer from './components/CompanyFilesContainer';

export default CompanyFilesContainer;
